import { Box, Button, Typography } from "@mui/material";
import { isPast } from "date-fns";
import NextImage from "next/legacy/image";
import { useTranslation } from "next-i18next";
import bannerBg from "public/img/banner-bg.png";
import { WfHeading } from "src/components-mui/base/wf-heading/wf-heading";
import { useRouterLocale } from "src/utils/router/use-router-locale";

const LANDING_PAGE_PATH = "l/smart-up-competition";

// Temporary component for Iphone 17 competition (to be removed after 14.11.2025) [COM-3755]
export const IphoneCompetitionBanner = () => {
    const { country, language } = useRouterLocale();
    const { t } = useTranslation(["reactions"]);

    if (isPast(new Date(process?.env?.NEXT_PUBLIC_IPHONE_COMPETITION_END_DATE || "2025.11.14"))) {
        return null;
    }

    return (
        <Box width="100%" borderRadius={1} p={2} mb={2} sx={{ backgroundImage: `url(${bannerBg.src})` }} position="relative" overflow="hidden">
            <Box
                position="absolute"
                top={["unset", "24px", "24px", "24px"]}
                right={["-25px", "40px", "0", "40px"]}
                bottom={["-20px", "unset", "unset", "unset"]}
                width={["144px", "200px", "200px", "200px"]}
                height={["144px", "200px", "200px", "200px"]}
                zIndex={0}
            >
                <NextImage src="/img/banner-iphone.png" layout="fill" />
            </Box>
            <Box position="relative" zIndex={1}>
                <WfHeading fontSize={{ xs: "md", sm: "lg" }} component="h3">
                    {t("competition.headline")}
                </WfHeading>
                <Typography fontSize={["sm", "md"]} mt={0.5} mb={1} width={["210px", "420px", "360px", "437px"]}>
                    {t("competition.description")}
                </Typography>
                <Button component="a" href={`/${language}/${country}/${LANDING_PAGE_PATH}`} size="small">
                    {t("competition.button")}
                </Button>
            </Box>
        </Box>
    );
};
